import { useSearchOrList } from '@/utils/api/membership-service'
import type { SearchOrListParams } from '@/utils/api/membership-service/models/search-or-list-params'
import type { TrainingNeedResponseDTO } from '@/utils/api/membership-service/models/training-need-response-dt-o'
import type { PageTrainingNeedResponseDTO } from '@/utils/api/membership-service/models/page-training-need-response-dt-o'
import type { TrainingNeedsQueryResult, TrainingNeedItem } from '../types'

function mapTrainingNeed(entry: TrainingNeedResponseDTO): TrainingNeedItem {
  return {
    id: typeof entry.id === 'number' ? entry.id : -1,
    topic: entry.topic ?? 'Untitled training need',
    organisationName: entry.organisationName ?? 'Unspecified organisation',
    createdAt: entry.createdAt ?? null,
    updatedAt: entry.updatedAt ?? null,
    createdBy: typeof entry.createdBy === 'number' ? entry.createdBy : null,
  }
}

function mapResponse(page: PageTrainingNeedResponseDTO | undefined): TrainingNeedsQueryResult {
  const content = Array.isArray(page?.content) ? page?.content : []
  const items = content.map((entry) => mapTrainingNeed(entry))

  return {
    items,
    page: typeof page?.number === 'number' ? page.number : 0,
    size: typeof page?.size === 'number' && page.size > 0 ? page.size : items.length || 10,
    totalElements:
      typeof page?.totalElements === 'number'
        ? page.totalElements
        : items.length,
    totalPages: typeof page?.totalPages === 'number' ? page.totalPages : 1,
  }
}

export interface UseTrainingNeedsQueryOptions {
  /**
   * Enables or disables the underlying query.
   */
  enabled?: boolean
}

export function useTrainingNeedsQuery(
  params: SearchOrListParams | undefined,
  options?: UseTrainingNeedsQueryOptions,
) {
  return useSearchOrList<TrainingNeedsQueryResult>(
    params,
    {
      query: {
        enabled: options?.enabled,
        staleTime: 30_000,
        select: (response) => mapResponse(response.data),
      },
    },
  )
}
